import createTableStore from "ds/components/Table/store/useTableStore";

import {
  USER_PERSONAL_API_KEYS_COLUMN_CONFIG,
  USER_PERSONAL_API_KEYS_COLUMNS_STORAGE_KEY,
} from "./constants";

const useUserPersonalApiKeysTableStore = createTableStore({
  storageKey: USER_PERSONAL_API_KEYS_COLUMNS_STORAGE_KEY,
  config: USER_PERSONAL_API_KEYS_COLUMN_CONFIG,
});

export default useUserPersonalApiKeysTableStore;
